import {KeyData, KeySnapshot} from "../../../api/Model";
import {naturalCmpOptions, stringCmp} from "../../../util/SortUtil";

export function lostAndDamagedCards(keys: KeyData[]): KeySnapshot[] {
    return keys
        .flatMap(key => key.history
            .filter(record => !record.to && (record.location.type === 'lost' || record.location.type === 'damaged'))
            .map(historyRecord => ({key, historyRecord}))
        )
        .sort(stringCmp(snapshot => snapshot.key.keyNumber, false, naturalCmpOptions));
}
